export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export function lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1)
}

export function singular(string){
    var lastChar = string.slice(-1)
    if(lastChar !== 's'){
        return string
    }
    return string.slice(0,-1)
}

export function formatPhoneNumberAWS(phone_number) {
    var formattedPhoneNumber = '+' + phone_number.replace(/[-+\s.()]/g,'')
    return formattedPhoneNumber
}

export function formatPhoneNumberNice(phone_number) {
    var formattedPhoneNumber = phone_number
    if(formattedPhoneNumber.charAt(0) === '+'){
        formattedPhoneNumber = formattedPhoneNumber.slice(1)
    }
    
}

export function formatErrorMessage(error_message){
    var formattedErrorMessage = error_message
    if((formattedErrorMessage.split(' ')[0] === 'Your')){
        formattedErrorMessage = formattedErrorMessage.slice(5)
    }
    if(formattedErrorMessage.slice(-1) === '.'){
        formattedErrorMessage = formattedErrorMessage.slice(0,-1)
    }
    return formattedErrorMessage
}